module.exports = __webpack_public_path__ + "static/media/dfappstore.d589ed49.svg";